import React, { useState , useEffect} from 'react';
import Modal from "react-modal";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {addMovieFeeling , removeMovieFeeling} from "../../functions/firestore.js";
import { useCookies } from 'react-cookie';

Modal.setAppElement(`#___gatsby`);


export default function Movieinfo(props) {

    const [cookies] = useCookies(['user']);
    const [modalOpen, setModalOpen] = useState(false);
    const [movieInfo, setMovieInfo] = useState(props.data);
    const [count, countR] = useState(0);

    const modalCloseTimeout = 150;
    
    //HANDLING MODAL CHANGES
    useEffect(() => {   
      setModalOpen(props.modalvisible); 
      setMovieInfo(props.data);
      countR(countReviews());
    }, [props.modalvisible , movieInfo, cookies.user, count, props.data])

    function countReviews(){
      if(movieInfo.moviefeelings){
      const counter = movieInfo.moviefeelings.reduce((accumulator, currentValue) => accumulator + currentValue[0].length, 0);
      return counter;
      }
    } 



    function handleChange() {   props.onChange(false);  }

    let setFeelingsForMovie = async (document_id, name) => {   
      const id = await addMovieFeeling(cookies.user, document_id, name);
      const data = movieInfo.allmoviefeelings.push({"name": name,"doc_id": id,"userid": cookies.user});

      const index = movieInfo.moviefeelings.findIndex( str => str[0].feeling['name'] === name);
      index >= 0 ? movieInfo.moviefeelings[index][0].length += 1 : movieInfo.moviefeelings.push([{"feeling":{"name": name},"length":1}]);
    

      setMovieInfo([movieInfo , data]);
    };

    let removeFeelingsForMovie = async (document_id, feeling_id, feeling_name) => {   
      let data;

      await removeMovieFeeling( document_id  , feeling_id );
      //REMOVE FROM MOVIE FEELINGS
      const index = movieInfo.moviefeelings.findIndex( str => str[0].feeling['name'] === feeling_name );
      index >= 0 && movieInfo.moviefeelings[index][0].length > 1 ? movieInfo.moviefeelings[index][0].length -= 1 : movieInfo.moviefeelings.splice(index,1);

      //REMOVE FROM ALL FEELINGS
      const index2 = movieInfo.allmoviefeelings.findIndex( str => str.doc_id === feeling_id );
      data = movieInfo.allmoviefeelings.splice(index2,1);

      setMovieInfo([movieInfo , data]);
    }
    
    return (
      <Modal
        isOpen={modalOpen}
        onRequestClose={handleChange}
        contentLabel="Modal"
        closeTimeoutMS={modalCloseTimeout}         
      >
      <div className="container-fluid no_padding">
        <div className="row">
          <div className="col-12 no_padding movieimagepreview">
            <a className = "exitModal" onClick={() => { handleChange(); }}> <FontAwesomeIcon icon={["fas", "times"]} /> </a>
            <img src={movieInfo.movie_image} className = "img-fluid" />
            <div className="shadowover"></div>
          </div>
        </div>


        <div className="row pad_30">
          {/* MOVIE DESCRIPTION  */}
          <div className="col-6 moviemodaldesc">
              <h3>{movieInfo.title} ({movieInfo.year})</h3>
              <span>
              {
                movieInfo.category && movieInfo.category.map((data,index)=>{
                  return(
                    <span key={data.label.name}> 
                      {data.label} 
                      {index !== movieInfo.category.length-1 &&
                      <span>
                        ,
                      </span>
                      }
                    </span>
                    )
                  })
              }
            </span>
              <p>{movieInfo.description}</p>
              <p><a target="_blank" className="trailer" href={movieInfo.movie_link}> <FontAwesomeIcon icon={["fab", "imdb"]} /> Watch Trailer </a></p>
          </div>    
          {/* MOVIE REVIEWS  */}
          <div className="col-3 offset-1 moviemodalreviews">
            {
              movieInfo.moviefeelings && movieInfo.moviefeelings.map(data=>{
                return(
                <div key={data[0].feeling.name}>
                  <span> {data[0].feeling.name} ({data[0].length})</span>
                  <div className="progress">
                    <div className="progress-bar bg-warning" role="progressbar" style={{width: (data[0].length / count) * 100 + '%'}}  aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                  <label>{parseFloat((data[0].length / count) * 100).toFixed(2)} %</label>           
                </div>
                )
              })
            }
          </div>
        </div>

        <div className = "row pad_30">
          {/* NEW REVIEWS  */}
          <div className="col-12 newreviews">
            <h3>Rate this movie:</h3>
            {
              props.datafeelings && props.datafeelings.map(data=>{
                let disabled = '';
                if(movieInfo.allmoviefeelings){
                  disabled = movieInfo.allmoviefeelings.filter( str => str['name'] === data.feeling_name && str['userid'] === cookies.user )
                }
                if(disabled && disabled.length){
                  return(<a key={`f${data.feeling_name}`} onClick={() => { removeFeelingsForMovie(movieInfo.id, disabled[0].doc_id, data.feeling_name)}} className="active"> <h5>{data.feeling_name} <FontAwesomeIcon icon={["fas", "check-circle"]}  /></h5></a>)
                }else{
                  return(<a key={`fs${data.feeling_name}`} onClick={(e) => { e.preventDefault(); setFeelingsForMovie(movieInfo.id, data.feeling_name) }}> <h5>{data.feeling_name} <FontAwesomeIcon icon={["fas", "check-circle"]} />  </h5></a>)
                }
              })
            }
          </div>
        </div>
      </div>
      </Modal>
    )
}

